var m = require('mithril');
var helpModal = require('../../help/helpModal');

var BASE_CONTAINER_CLASSES = [
  'v-btm',
  'bb',
  'b--mid-gray',
  'bw1',
  'f-subheadline',
  'mb3',
  'display',
  'pb2'
];

function parseClassList(classString) {
  if (!classString || typeof classString !== 'string') {
    return [];
  }

  return classString
    .replace(/\./g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
}

function buildContainerSelector(customClassString) {
  var customClasses = parseClassList(customClassString);
  var overridesMarginBottom = customClasses.some(function (className) {
    return /^mb\d+/i.test(className);
  });
  var overridesPaddingBottom = customClasses.some(function (className) {
    return /^pb\d+/i.test(className);
  });
  var overridesFontSize = customClasses.some(function (className) {
    return /^f(\d|-[a-z]+)/i.test(className);
  });

  var normalizedDefaults = BASE_CONTAINER_CLASSES.filter(function (className) {
    if (overridesMarginBottom && className.indexOf('mb') === 0) return false;
    if (overridesPaddingBottom && className.indexOf('pb') === 0) return false;
    if (overridesFontSize && className.indexOf('f-') === 0) return false;
    return true;
  });

  var classList = normalizedDefaults.concat(customClasses);

  return 'div' + classList.map(function (className) {
    return '.' + className;
  }).join('');
}

var pathHeader = {};

pathHeader.oninit = function (vnode){
  var ctrl = this;
  ctrl.ancestors = vnode.attrs.ancestors || [];
  ctrl.record = vnode.attrs.record || {};
  ctrl.renderLeaf = typeof vnode.attrs.renderLeaf === 'function' ? vnode.attrs.renderLeaf : null;
}

pathHeader.onupdate = function(vnode){
  var ctrl = this;
  if (
    vnode.attrs.record['@rid'] != ctrl.record['@rid'] || 
    vnode.attrs.record['name'] != ctrl.record['name'] || 
    (ctrl.ancestors.length >= 2 && ctrl.ancestors[ctrl.ancestors.length - 2]['@rid'].toString() != vnode.attrs.ancestors[vnode.attrs.ancestors.length - 2]['@rid'].toString())
  ) {
    ctrl.record = vnode.attrs.record || {};
    ctrl.ancestors = vnode.attrs.ancestors || [];
    ctrl.renderLeaf = typeof vnode.attrs.renderLeaf === 'function' ? vnode.attrs.renderLeaf : null;
    m.redraw();
  } else if (ctrl.renderLeaf !== vnode.attrs.renderLeaf) {
    ctrl.renderLeaf = typeof vnode.attrs.renderLeaf === 'function' ? vnode.attrs.renderLeaf : null;
  }
}

pathHeader.view = function (vnode) {
  var ctrl = this;
  var containerSelector = buildContainerSelector(vnode.attrs.class);
  return m(containerSelector, [
    m('div.flex.flex-wrap', [
      ctrl.ancestors.map( function (ancestor, idx) {
        if (ancestor['@rid'] === ctrl.record['@rid']) {
          if (ctrl.renderLeaf) {
            return ctrl.renderLeaf({
              ancestor: ancestor,
              index: idx,
              ancestors: ctrl.ancestors,
              record: ctrl.record
            });
          }
          return m('div.mr2.dib-ns', 
            ctrl.record.name == 'root' ? 
              'Home'
            : 
              ctrl.record['@class'] == 'Room' ? 
                `${ctrl.record.name} ${ctrl.record.roomNumber || ''}` 
              : 
                ctrl.record.name ? 
                  ctrl.record.name 
                : 
                  ctrl.record['@class']);
        } else if(ancestor.name == 'root'){
          return m('div.mr2.dib-ns',[
            m(m.route.Link, {href: `/location${m.route.get().split('?')[1] ? `?${m.route.get().split('?')[1]}`:''}`}, 'Home'),
          ' / '
          ]);
        } else if (ancestor['@class'] == 'Site' || ancestor['@class'] == 'Building' || ancestor['@class'] == 'Level' || ancestor['@class'] == 'Room' ) {
          return m('div.mr2.dib-ns',[
            m(m.route.Link, {
              href: `/location/${ancestor['@rid'].slice(1)}${m.route.get().split('?')[1] ? `?${m.route.get().split('?')[1]}`:''}`
            }, ancestor['@class'] == 'Room' ? 
                `${ancestor.name} ${ancestor.roomNumber || ''}` 
              : 
                ancestor.name
            ),
          ' / '
          ]);
        } else if (ancestor['@class'] == 'System') {
          return m('div.mr2.dib-ns',[
            m(m.route.Link, {href: '/system/' + ancestor['@rid'].slice(1)}, ancestor.name || ancestor['@class']),
          ' / '
          ]);
        } else {
          return m('div.mr2.dib-ns',[
            m(m.route.Link, {href: '/equipment/'+ancestor['@class'].toLowerCase()+'/' + ancestor['@rid'].slice(1)}, ancestor.name || ancestor['@class']),
          ' / '
          ]);
        }
      }),
      vnode.attrs.helpIcon ? 
        m('i.ion-ios-help-outline.white.f2.ml2', {
          onclick: () => {
            helpModal.editDialogue(vnode.attrs.helpModalTitle, vnode.attrs.helpFileName)
          }
        })
      :
        ''

    ]),
    vnode.children
  ])
}

module.exports = pathHeader;
